import { helper } from '@ember/component/helper';
import { assert } from '@ember/debug';

export function closestIncrement(date, increment) {
  if (date && increment) {
    assert(date instanceof Date, 'date must be a Date object');

    let minutes = date.getMinutes();
    let closest = Math.round(minutes / increment) * increment;
    let newDate = date.setMinutes(closest);
    newDate = date.setSeconds(0);
    newDate = date.setMilliseconds(0);

    if (newDate?.getTime) {
      return newDate;
    } else {
      return date;
    }
  } else {
    return date;
  }
}

export default helper(function closestIncrementHelper(params, options) {
  let [date] = params;
  let increment = options.increment || 1;
  return (value) => {
    return closestIncrement(value, increment)
  }
});
